import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getBuckets } from 'services/post/actions'
import { Bucket } from 'shared/types'
import { StoreThunkDispatch } from 'store/state'

interface FetchBucketsProps {
  force?: boolean
  onFetched?: (buckets: Bucket[]) => void
  onError?: (error: any) => void
}

export function FetchBuckets(props: FetchBucketsProps) {
  const { force, onError, onFetched } = props
  const dispatch = useDispatch<StoreThunkDispatch>()

  useEffect(() => {
    dispatch(getBuckets(Boolean(force)))
      .unwrap()
      .then(res => {
        if (onFetched) {
          onFetched(res.buckets)
        }
      })
      .catch(onError)
  }, [dispatch, force, onError, onFetched])

  return null
}
